import React from 'react';

const IconTrend = () => {
    return <svg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M14.334 12V13H0.333984V12H14.334ZM14.334 0V5H12.994V2.34L8.33398 7L6.33398 5L0.333984 11V9L6.33398 3L8.33398 5L11.964 1.37H9.33398V0H14.334Z' fill='#1F1F1F' />
    </svg>;
};

export default IconTrend;
